const services = [
  {
    bg: 'bg-teal-100', color: 'text-teal-700', checkColor: 'text-teal-600',
    icon: 'ri-store-3-line', title: '店舗開業支援',
    text: '立地選定、店舗設計、メニュー開発、スタッフ採用まで、開業に必要なすべてをサポートします。',
    items: ['事業計画策定', '資金調達サポート', '開業準備全般'],
  },
  {
    bg: 'bg-amber-100', color: 'text-amber-700', checkColor: 'text-amber-600',
    icon: 'ri-bar-chart-box-line', title: '収益改善',
    text: '売上向上とコスト削減の両面から、収益性の改善を実現します。',
    items: ['売上分析・改善提案', '原価管理最適化', '価格戦略立案'],
  },
  {
    bg: 'bg-rose-100', color: 'text-rose-700', checkColor: 'text-rose-600',
    icon: 'ri-group-line', title: '人材育成',
    text: 'スタッフの能力向上と定着率改善で、サービス品質を高めます。',
    items: ['接客研修プログラム', '調理技術指導', 'マネジメント研修'],
  },
  {
    bg: 'bg-purple-100', color: 'text-purple-700', checkColor: 'text-purple-600',
    icon: 'ri-restaurant-line', title: 'メニュー開発',
    text: 'コンセプトに合わせた魅力的なメニューを開発し、競争力を高めます。',
    items: ['メニュー構成提案', 'レシピ開発支援', '原価計算・価格設定'],
  },
  {
    bg: 'bg-emerald-100', color: 'text-emerald-700', checkColor: 'text-emerald-600',
    icon: 'ri-megaphone-line', title: 'マーケティング',
    text: '効果的な集客戦略で、新規顧客の獲得とリピーター育成を実現します。',
    items: ['SNS活用支援', 'プロモーション企画', 'ブランディング戦略'],
  },
  {
    bg: 'bg-cyan-100', color: 'text-cyan-700', checkColor: 'text-cyan-600',
    icon: 'ri-settings-3-line', title: '運営改善',
    text: 'オペレーションの効率化で、生産性向上とコスト削減を実現します。',
    items: ['業務フロー改善', 'システム導入支援', '品質管理体制構築'],
  },
];

export default function ConsultingSection() {
  return (
    <section id="consulting" className="py-14 md:py-24 bg-gradient-to-br from-slate-50 to-gray-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-16">
          <div className="inline-block bg-teal-100 text-teal-700 px-3 py-1 rounded-full text-xs font-medium mb-4 md:mb-6">
            Consulting Services
          </div>
          <h2 className="text-2xl md:text-5xl font-bold text-slate-800 mb-3 md:mb-6 leading-tight">
            経営コンサルティング
          </h2>
          <p className="text-sm md:text-lg text-gray-700 max-w-3xl mx-auto leading-relaxed">
            実践で培った経験とノウハウで、飲食店経営のあらゆる課題を解決します
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8 mb-10 md:mb-16">
          {services.map((s) => (
            <div key={s.title} className="bg-white rounded-xl md:rounded-2xl p-5 md:p-8 hover:shadow-lg transition-all duration-300">
              <div className={`w-11 h-11 md:w-14 md:h-14 flex items-center justify-center ${s.bg} rounded-xl mb-4 md:mb-6`}>
                <i className={`${s.icon} text-2xl md:text-3xl ${s.color}`}></i>
              </div>
              <h3 className="text-base md:text-xl font-bold text-slate-800 mb-2 md:mb-4">{s.title}</h3>
              <p className="text-xs md:text-base text-gray-600 leading-relaxed mb-3 md:mb-4">{s.text}</p>
              <ul className="space-y-1 md:space-y-2">
                {s.items.map((item) => (
                  <li key={item} className="flex items-center gap-2 text-xs md:text-sm text-gray-600">
                    <i className={`ri-check-line ${s.checkColor}`}></i>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-teal-700 to-teal-800 rounded-2xl md:rounded-3xl p-8 md:p-12 text-white text-center">
          <h3 className="text-xl md:text-3xl font-bold mb-3 md:mb-4">50店舗以上の実績</h3>
          <p className="text-sm md:text-lg text-teal-100 mb-6 md:mb-8 max-w-2xl mx-auto leading-relaxed">
            創業以来、多様な業態の飲食店開業・経営改善をサポートしてまいりました。
            実践的なノウハウで、あなたのビジネスの成功を実現します。
          </p>
          <div className="grid grid-cols-3 gap-4 md:gap-8 max-w-4xl mx-auto">
            {[
              { val: '50+', label: '支援店舗数' },
              { val: '15年', label: '業界経験' },
              { val: '150%', label: '平均売上改善率' },
            ].map((stat) => (
              <div key={stat.label}>
                <div className="text-2xl md:text-5xl font-bold mb-1 md:mb-2">{stat.val}</div>
                <div className="text-xs md:text-base text-teal-200">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
